// extracted by mini-css-extract-plugin
export var ellipsis = "styles-module--ellipsis--9f5c5";
export var hasError = "styles-module--hasError--216d3";
export var iconDown = "styles-module--iconDown--05539";
export var iconUp = "styles-module--iconUp--65bc6";
export var light = "styles-module--light--140d8";
export var list = "styles-module--list--8fac0";
export var regular = "styles-module--regular--48b14";
export var searchBlock = "styles-module--searchBlock--0db83";
export var selectButton = "styles-module--selectButton--a4a00";
export var selectItem = "styles-module--selectItem--e56c5";
export var selectPlaceholder = "styles-module--selectPlaceholder--8be38";
export var selectPopover = "styles-module--selectPopover--1ea1b";